<template>
  <path d="M12.4997 7.28917H7.28917V12.4997H5.55232V7.28917H0.341797V5.55232H5.55232V0.341797H7.28917V5.55232H12.4997V7.28917Z" fill="#0FA38E"></path>
</template>

<script>
    export default {
        name: 'icon-plus'
    }
</script>